const TYPES = Object.freeze({
  BAR: 'bar',
  BUBBLE: 'bubble',
  DOUGHNUT: 'doughnut',
  LINE: 'line',
  PIE: 'pie',
  POLAR_AREA: 'polarArea',
  RADAR: 'radar',
  SCATTER: 'scatter',
});

export default Object.freeze({
  TYPES,
});
